import { useRef } from "react";
import * as api from '../services/api'

export default function FileManager({ selectedModel, csvFile, loadCsvFiles }) {
    const fileRef = useRef(null);

    const handleFileClick = () => {
        fileRef.current.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = async () => {
            const base64Data = reader.result.split(",")[1]; // remove prefix
            const payload = {
                fileName: file.name,
                base64Data: base64Data,
            };

            try {
                await api.upload(payload, selectedModel);
            } catch (err) {
                console.error(err);
                alert("Upload failed");
            } finally {
                loadCsvFiles();
            }
        };

        reader.readAsDataURL(file); // read file as base64
    };

    const downloadCsv = () => {
        api.getMappingCSV(selectedModel, csvFile)
            .then(async (response) => {
            })
            .catch(err => {
                alert(err);
            });
    }


    return (
        <div className="flex items-center gap-2">
            <p
                onClick={downloadCsv}
                className="whitespace-nowrap text-blue-500 font-bold text-xs underline decoration-dotted cursor-pointer"
            >
                {csvFile}
            </p>
            <input
                type="file"
                accept=".csv"
                ref={fileRef}
                onChange={handleFileChange}
                className="hidden"
            />

            {/* Upload button */}
            <button
                type="button"
                onClick={handleFileClick}
                className="bg-gray-50 text-gray-500 border-2 border-gray-600 font-bold rounded-lg px-2 py-1 whitespace-nowrap"
            >
                {csvFile ? "•••" : "Browse for File"}
            </button>
        </div>
    );
}
